module.exports = __webpack_public_path__ + "lp/img/manual_icon_sp_on@2x.adb3dbae.png";